export default [
  {
    path: "/financeiro/docs",
    name: "financeiro.docs",
    label: "Docs. Fiscais",
    component: () => import("@/components/financeiro/docsfiscais/home.vue"),
  },
  {
    path: "/financeiro/docs/nfe/gerenciar",
    name: "financeiro.docs.nfe",
    label: "Visualizar Lista de NF-e",
    component: () => import("@/components/compras/compras/gerenciar-notas-importadas.vue"),
  },
  {
    path: "/financeiro/docs/cte/gerenciar",
    name: "financeiro.docs.cte",
    label: "Visualizar Lista de CT-e",
    component: () => import("@/components/logistica/cte/gerenciar-cte-importados.vue"),
  },
  {
    path: "/financeiro/docs/cte/importar",
    name: "financeiro.docs.cte.importar",
    label: "Importar CT-e manualmente",
    component: () => import("@/components/logistica/cte/importar-cte.vue"),
  },
  {
    path: "/financeiro/docs/cte/visualizar/:id",
    name: "financeiro.docs.cte.show",
    label: "Visualizar Detalhes de CT-e Importada",
    component: () => import("@/components/logistica/cte/cte-importada-show.vue"),
  },
  {
    path: "/financeiro/docs/nfe-industria/:id",
    name: "financeiro.docs.nfe.importada-industria",
    label: "Visualizar Detalhes de NF-e Importadas (Indústria)",
    component: () => import("@/components/compras/compras/nota-importada-industria.vue"),
  },
  {
    path: "/financeiro/docs/nfe-comercio/:id",
    name: "financeiro.docs.nfe.importada",
    label: "Visualizar Detalhes de NF-e Importadas (Comércio)",
    component: () => import("@/components/compras/compras/nota-importada.vue"),
  },
  {
    path: "/financeiro/docs/nfe/importar",
    name: "financeiro.docs.nfe.importar",
    label: "Importar NF-e manualmente",
    component: () => import("@/components/compras/compras/importar-NFe.vue"),
  },
  {
    component: () => import("@/components/financeiro/cadastros/centro-custo/centro-custo.vue"),
    name: "financeiro.cadastros.centro-custo",
    path: "/financeiro/cadastros/centro-custo",
    label: "Visualizar/Editar Centro de Custo",
  },
  {
    component: () => import("@/components/financeiro/cadastros/formas-pagamento/GerenciarFormasPagamento.vue"),
    name: "financeiro.cadastros.formas-pagamento-pagar",
    path: "/financeiro/cadastros/formas-pagamento-pagar",
    label: "Formas de Pagamento Pagar",
  },
  {
    component: () => import("@/components/faturamento/cadastros/formas-pagamento/GerenciarFormasPagamento.vue"),
    name: "financeiro.cadastros.formas-pagamento-receber",
    path: "/financeiro/cadastros/formas-pagamento-receber",
    label: "Formas de Pagamento Receber",
  },
  {
    component: () => import("@/components/financeiro/cadastros/cartao-bancario/cartao-bancario.vue"),
    name: "financeiro.cadastros.cartao-bancario",
    path: "/financeiro/cadastros/cartao-bancario/:id",
    label: "Visualizar Cartões Bancários",
  },
  {
    component: () => import("@/components/financeiro/cadastros/cartao-bancario/novo-cartao.vue"),
    name: "financeiro.cadastros.cartao-bancario.novo",
    label: "Cadastrar Cartões Bancários",
    path: "/financeiro/cadastros/novo-cartao/:conta",
  },
  {
    component: () => import("@/components/financeiro/cadastros/cartao-bancario/novo-cartao.vue"),
    name: "financeiro.cadastros.cartao-bancario.editar",
    label: "Editar Cartões Bancários",
    path: "/financeiro/cadastros/edita-cartao/:conta/:id",
  },
  {
    component: () => import("@/components/financeiro/cadastros/contas-bancarias/contas-bancarias.vue"),
    name: "financeiro.cadastros.contas-bancarias",
    path: "/financeiro/cadastros/contas-bancarias",
    label: "Visualizar Contas Bancárias",
  },
  {
    component: () => import("@/components/financeiro/transacoes/pagar/gerenciar-contas-pagar.vue"),
    name: "financeiro.transacoes.contas-pagar",
    path: "/financeiro/transacoes/contas-pagar",
    label: "Visualizar Lista de Contas a Pagar",
  },
  {
    component: () => import("@/components/financeiro/transacoes/receber/gerenciar-contas-receber.vue"),
    name: "financeiro.transacoes.contas-receber",
    path: "/financeiro/transacoes/contas-receber",
    label: "Visualizar Lista de Contas a Receber",
  },
  {
    component: () => import("@/components/financeiro/transacoes/pagar/visualizar-conta-pagar.vue"),
    name: "financeiro.transacoes.contas-pagar.visualizar",
    label: "Visualizar Detalhes da Conta a Pagar",
    path: "/financeiro/transacoes/contas-pagar/visualizar/:id",
  },
  {
    component: () => import("@/components/financeiro/transacoes/pagar/editor-conta-pagar.vue"),
    name: "financeiro.transacoes.contas-pagar.editar",
    label: "Editar Contas a Pagar",
    path: "/financeiro/transacoes/contas-pagar/editar/:id",
  },
  {
    component: () => import("@/components/financeiro/transacoes/pagar/editor-conta-pagar.vue"),
    name: "financeiro.transacoes.contas-pagar.novo",
    label: "Cadastrar Contas a Pagar",
    path: "/financeiro/transacoes/contas-pagar/novo",
  },
  {
    component: () => import("@/components/financeiro/transacoes/receber/editor-conta-receber.vue"),
    name: "financeiro.transacoes.contas-receber.novo",
    label: "Cadastrar Contas a Receber",
    path: "/financeiro/transacoes/contas-receber/novo",
  },
  {
    component: () => import("@/components/financeiro/transacoes/receber/editar-conta-receber.vue"),
    name: "financeiro.transacoes.contas-receber.editar",
    label: "Editar Conta a Receber",
    path: "/financeiro/transacoes/contas-receber/editar/:id",
  },
  {
    component: () => import("@/components/financeiro/boletos/gerenciar-boletos.vue"),
    name: "financeiro.boletos.gerenciar",
    path: "/financeiro/boletos/gerenciar",
    label: "Visualizar Lista de Boletos",
  },
  {
    component: () => import("@/components/financeiro/boletos/gerenciar-boletos-detalhes.vue"),
    name: "boletos-detalhes",
    path: "/financeiro/boletos/:id",
    label: "Visualizar Detalhes do Boleto",
  },
  {
    component: () => import("@/components/financeiro/cadastros/cheques/gerenciar-cheques.vue"),
    name: "financeiro.cadastros.cheques",
    path: "/financeiro/cadastros/cheques",
    label: "Visualizar Cheques",
  },
  {
    component: () => import("@/components/financeiro/cadastros/especies/gerenciar-especies.vue"),
    name: "financeiro.cadastros.especies",
    path: "/financeiro/cadastros/especies",
    label: "Visualizar Espécies",
  },
  {
    component: () => import("@/components/financeiro/cadastros/especies/gerenciar-especies-padrao.vue"),
    name: "financeiro.cadastros.especies.padrao",
    path: "/financeiro/cadastros/especies/padrao",
    label: "Visualizar Espécies Padrão",
  },
  {
    component: () => import("@/components/financeiro/boletos/gerenciar-remessa.vue"),
    name: "financeiro.boletos.remessas",
    path: "/financeiro/boletos/remessas",
    label: "Visualizar Lista de Remessas",
  },
  {
    component: () => import("@/components/financeiro/boletos/gerenciar-remessa-show.vue"),
    name: "financeiro.boletos.remessas.visualizar",
    label: "Visualizar Detalhes das Remessas",
    path: "/financeiro/boletos/remessas-show/editar/:id",
  },
  {
    component: () => import("@/components/financeiro/boletos/gerenciar-retornos.vue"),
    name: "financeiro.boletos.retornos",
    path: "/financeiro/boletos/retornos",
    label: "Visualizar Lista de Retornos",
  },
  {
    component: () => import("@/components/financeiro/boletos/home-boletos.vue"),
    name: "financeiro.boletos",
    path: "/financeiro/boletos",
    label: "Boletos",
  },
  {
    component: () => import("@/components/financeiro/cadastros/home-cadastros.vue"),
    name: "financeiro.cadastros",
    path: "/financeiro/cadastros",
    label: "Cadastros",
  },
  {
    component: () => import("@/components/financeiro/relatorios/home-relatorios.vue"),
    name: "financeiro.relatorios",
    path: "/financeiro/relatorios",
    label: "Relatórios",
  },
  {
    component: () => import("@/components/financeiro/relatorios/grafico-barras-pagar-receber.vue"),
    name: "financeiro.relatorios.grafico-barras",
    path: "/financeiro/relatorios/grafico-barras",
    label: "Gráfico de Barras Pagar/Receber",
  },
  {
    component: () => import("@/components/financeiro/relatorios/relatorio-financeiro-receber-database.vue"),
    name: "financeiro.relatorios.financeiro-receber-database",
    path: "/financeiro/relatorios/financeiro-receber-database",
    label: "Relatório de Financeiro Receber Database",
  },
  {
    component: () => import("@/components/financeiro/relatorios/relatorio-financerio-pagar-database.vue"),
    name: "financeiro.relatorios.financeiro-pagar-database",
    path: "/financeiro/relatorios/financeiro-pagar-database",
    label: "Relatório de Financeiro Pagar Database",
  },
  {
    component: () => import("@/components/financeiro/transacoes/HomeTransacoes.vue"),
    name: "financeiro.transacoes",
    path: "/financeiro/transacoes",
    label: "Transações Financeiras",
  },
  {
    component: () => import("@/components/financeiro/bancos/home-bancos.vue"),
    name: "financeiro.bancos",
    path: "/financeiro/bancos",
    label: "Bancos",
  },
  {
    component: () => import("@/components/financeiro/boletos/importar-retornos.vue"),
    name: "financeiro.boletos.retornos.importar",
    label: "Importar Retornos",
    path: "/financeiro/boletos/retornos/importar",
  },
  {
    component: () => import("@/components/home/MenuFinanceiro.vue"),
    name: "financeiro",
    label: "Financeiro",
    path: "/financeiro",
  },
  {
    component: () => import("@/components/financeiro/boletos/nova-remessa.vue"),
    name: "financeiro.boletos.remessas.novo",
    label: "Criar Remessas",
    path: "/financeiro/boletos/remessas/nova",
  },
  {
    component: () => import("@/components/financeiro/boletos/envios.vue"),
    name: "financeiro.boletos.envios",
    label: "Envios de Boletos",
    path: "/financeiro/boletos/envios",
  },
  {
    component: () => import("@/components/financeiro/cadastros/cheques/novo-cheque.vue"),
    name: "financeiro.cadastros.cheques.novo",
    label: "Cadastrar Cheques",
    path: "/financeiro/cadastros/cheques/novo-cheque",
  },
  {
    component: () => import("@/components/financeiro/cadastros/cheques/novo-cheque.vue"),
    name: "financeiro.cadastros.cheques.editar",
    label: "Editar Cheques",
    path: "/financeiro/cadastros/cheques/edit-cheque/:id",
  },
  {
    component: () => import("@/components/financeiro/cadastros/contas-bancarias/editor-contas-bancarias.vue"),
    name: "financeiro.cadastros.contas-bancarias.novo",
    path: "/financeiro/cadastros/contas-bancarias/novo",
    label: "Cadastrar Contas Bancárias",
  },
  {
    component: () => import("@/components/financeiro/cadastros/contas-bancarias/editor-contas-internas.vue"),
    name: "financeiro.cadastros.contas-internas.novo",
    path: "/financeiro/cadastros/contas-internas/novo",
    label: "Cadastrar Conta Interna",
  },
  {
    component: () => import("@/components/financeiro/cadastros/contas-bancarias/editor-contas-bancarias.vue"),
    name: "financeiro.cadastros.contas-bancarias.editar",
    label: "Editar Contas Bancárias",
    path: "/financeiro/cadastros/contas-bancarias/editar/:id",
  },
  {
    component: () => import("@/components/financeiro/cadastros/planos-de-contas/planos-de-contas.vue"),
    name: "financeiro.cadastros.planos-de-contas",
    path: "/financeiro/cadastros/planos-de-contas",
    label: "Visualizar/Editar Planos de Contas",
  },
  {
    component: () => import("@/components/financeiro/cadastros/historicos-financeiros/historicos-financeiros.vue"),
    name: "financeiro.cadastros.historicos-financeiros",
    path: "/financeiro/cadastros/historicos-financeiros",
    label: "Visualizar/Editar Históricos Financeiros",
  },
  {
    component: () => import("@/components/financeiro/relatorios/relatorio-balancete-gerencial.vue"),
    name: "financeiro.relatorios.balancete-gerencial",
    label: "Relatório de Balancete Gerencial",
    path: "/financeiro/relatorios/balancete-gerencial",
  },
  {
    component: () => import("@/components/financeiro/bancos/conciliacao-bancaria.vue"),
    name: "financeiro.bancos.conciliacao",
    path: "/financeiro/transacoes/conciliacao-bancaria",
    label: "Visualizar Conciliação Bancária",
  },
  {
    component: () => import("@/components/financeiro/bancos/configuracoes-conciliacao.vue"),
    name: "financeiro.bancos.configuracoes-conciliacao",
    path: "/financeiro/bancos/configuracoes-conciliacao",
    label: "Configurações de Conciliação",
  },
  {
    component: () => import("@/components/financeiro/configuracoes/configuracoes-financeiro.vue"),
    name: "financeiro.configuracoes",
    path: "/financeiro/configuracoes",
    label: "Configurações do Financeiro",
  },
  {
    component: () => import("@/components/financeiro/bancos/extrato-bancario.vue"),
    name: "financeiro.bancos.extrato",
    path: "/financeiro/bancos/extrato",
    label: "Visualizar Extrato Bancário",
  },
  {
    component: () => import("@/components/financeiro/bancos/saldos.vue"),
    name: "financeiro.bancos.saldos",
    path: "/financeiro/bancos/saldos",
    label: "Visualizar Saldos",
  },
  {
    component: () => import("@/components/financeiro/bancos/conta-bancaria.vue"),
    name: "financeiro.bancos.conta-bancaria",
    path: "/financeiro/bancos/conta-bancaria",
    label: "Conta Bancária",
  },
  {
    component: () => import("@/components/financeiro/bancos/cartoes/configuracao-cartoes.vue"),
    name: "financeiro.bancos.cartoes",
    path: "/financeiro/bancos/cartoes",
    label: "Cartões de Crédito",
  },
  {
    component: () => import("@/components/financeiro/relatorios/relatorio-comissao.vue"),
    name: "financeiro.relatorios.comissaorep",
    path: "/financeiro/relatorios/comissao/representantes",
    label: "Relatório de Comissão de Representantes",
  },
  {
    component: () => import("@/components/financeiro/relatorios/relatorio-comissao-clientes.vue"),
    name: "financeiro.relatorios.comissaorepcli",
    label: "Relatório de Comissão por Clientes",
    path: "/financeiro/relatorios/comissao/clientes",
  },
  {
    component: () => import("@/components/financeiro/relatorios/relatorio-comissao-produto.vue"),
    name: "financeiro.relatorios.comissao-produtos",
    path: "/financeiro/relatorios/comissao/produtos",
    label: "Relatório de Comissão por Produtos",
  },
  {
    component: () => import("@/components/financeiro/boletos/retorno-print.vue"),
    name: "financeiro.boletos.retornos.visualizar",
    label: "Visualizar Detalhes dos Retornos",
    path: "/financeiro/boletos/retorno/relatorio/:id",
  },
  {
    component: () => import("@/components/financeiro/relatorios/relatorio-demonstracao-do-resultado-do-exercicio.vue"),
    name: "financeiro.relatorios.dre",
    path: "/financeiro/relatorios/dre",
    label: "Relatório de Demonstração do Resultado do Exercício (DRE)",
  },
  {
    component: () => import("@/components/financeiro/relatorios/relatorio-provisionamentos.vue"),
    name: "financeiro.relatorios.provisionamentos",
    path: "/financeiro/relatorios/provisionamentos",
    label: "Relatório de Provisionamentos",
  },
  {
    component: () => import("@/components/financeiro/relatorios/relatorio-fluxo-caixa-mensal.vue"),
    name: "financeiro.relatorios.fluxo-caixa-mensal",
    path: "/financeiro/relatorios/fluxo-caixa-mensal",
    label: "Relatório de Fluxo de Caixa Mensal",
  },
  {
    component: () => import("@/components/financeiro/relatorios/relatorio-fluxo-caixa-diario.vue"),
    name: "financeiro.relatorios.fluxo-caixa-diario",
    path: "/financeiro/relatorios/fluxo-caixa-diario",
    label: "Relatório de Fluxo de Caixa Diario",
  },
  {
    component: () => import("@/components/financeiro/relatorios/relatorio-fluxo-caixa.vue"),
    name: "financeiro.relatorios.fluxo-caixa",
    path: "/financeiro/relatorios/fluxo-caixa",
    label: "Relatório de Fluxo de Caixa",
  },
];
